import { useCallback } from "react";
import { useRealCommerceErrorHandling } from "../../../hooks/useRealCommerceErrorHandling.js";
import { useStores } from "../../../store/stores.js";
/**
 * Customer Center V2 error handler. Wraps the generic `useRealCommerceErrorHandling`
 * so 500s / backend-down failures escalate to the inline `FatalError` view instead
 * of the legacy "Something went wrong on our end" modal — the modal blocks the user
 * with no path forward, the fatal-error page offers reload + support links.
 *
 * Per-call sites may still override `onBackendDown` to e.g. surface an inline error.
 */ function useAccountV2ErrorHandling() {
    const baseHandler = useRealCommerceErrorHandling();
    const { accountV2Store } = useStores();
    return useCallback((error, options = {})=>{
        baseHandler(error, {
            ...options,
            onBackendDown: options?.onBackendDown ?? ((e)=>accountV2Store.setFatalError(e))
        });
    }, [
        baseHandler,
        accountV2Store
    ]);
}
export { useAccountV2ErrorHandling };
